import { IPublicClientApplication } from '@azure/msal-browser';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { getStaffJudgingQuestions } from './index';

export const createStaffAwardsJudgingQuestionsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getStaffJudgingQuestions: (instance: IPublicClientApplication, awardId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getStaffJudgingQuestions(fetchContext, awardId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getStaffJudgingQuestions', isInFlight);
    },
  ),
});
